import { motion, useScroll, useSpring } from "framer-motion";

/**
 * ScrollProgress - Reading progress indicator
 * Thin coral line at top of viewport
 */
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-0.5 bg-primary origin-left z-[100]"
      style={{ scaleX }}
    />
  );
};
